var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "pickrContainer",
      staticClass: "d-inline-flex align-items-center picker-container",
    },
    [
      _c("div", { ref: "pickr" }),
      _vm._v(" "),
      _vm.copy
        ? _c("i", {
            class: [
              "cursor-pointer font-xl px-2 bi",
              _vm.copied ? "bi-check2" : "bi-copy",
            ],
            attrs: { title: "Copy hex color" },
            on: { click: _vm.copyColorToClipboard },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }